<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.issue' :placeholder="$t('期号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isXg' clearable
                                                      :placeholder="$t('类型') " style='width:120px'>
              <Option :value="'0'">{{ $t('新澳门') }}</Option>
              <Option :value="'1'">{{ $t('香港') }}</Option>
              <Option :value="'2'">{{ $t('老澳门') }}</Option>
              <Option :value="'7'" >{{ $t('快乐8') }}</Option>
              <Option :value="'4'" >{{ $t('柬埔寨') }}</Option>
              <Option :value="'5'" >{{ $t('台湾') }}</Option>
              <Option :value="'6'" >{{ $t('印尼') }}</Option>
              <Option :value="'7'" >{{ $t('马来西亚') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row> <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'Lhc/openLogAdd'" @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="900" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增(点击远程发布可以手动实时更新,更新完成,请更新到数据库)') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <table style="border-color: blue; " border="4">
          <thead>
          <th style="width: 80px;">类型</th>
          <th style="width: 150px;">完整期号</th>
          <th style="width: 100px;">期号</th>
          <th style="width: 300px;">下期期号</th>
          <th style="width: 300px;">本期开奖日期</th>
          <th style="width: 300px;">下期开奖日期</th>
          </thead>
          <tbody>
          <tr>
            <td style="text-align: center;"><Select clearable v-model='windowAddItem.isXg'
                                                    style='width:80px'>
              <Option :value="'0'" :key='0'>{{ $t('新澳门') }}</Option>
              <Option :value="'1'" :key='1'>{{ $t('香港') }}</Option>
              <Option :value="'2'" :key='2'>{{ $t('老澳门') }}</Option>
              <Option :value="'7'" :key='7'>{{ $t('快乐8') }}</Option>
              <Option :value="'4'" :key='4'>{{ $t('柬埔寨') }}</Option>
              <Option :value="'5'" :key='5'>{{ $t('台湾') }}</Option>
              <Option :value="'6'" :key='6'>{{ $t('印尼') }}</Option>
              <Option :value="'7'" :key='7'>{{ $t('马来西亚') }}</Option>
            </Select></td>
            <td style="text-align: center;"><Input clearable v-model='windowAddItem.yearIssue'
                                                   :placeholder="$t('请输入完整期号')"></Input></td>
            <td style="text-align: center;"><Input clearable v-model='windowAddItem.issue'
                                                   :placeholder="$t('请输入期号')"></Input></td>
            <td style="text-align: center;"><Input clearable v-model='windowAddItem.nextissue'
                                                   :placeholder="$t('如 003 (澳门可以不填)')"></Input></td>
            <td style="text-align: center;">

              <DatePicker :value='windowAddItem.openTime' type="date"
                          @on-change='windowAddItem.openTime=$event' format="yyyy-MM-dd 21:35:00"
                          :placeholder="$t('选择时间')" style="width: 200px"> </DatePicker>
            </td>
            <td style="text-align: center;">
              <DatePicker :value='windowAddItem.nextOpenTime' type="date"
                          @on-change='windowAddItem.nextOpenTime=$event' format="yyyy-MM-dd 21:30:00"
                          :placeholder="$t('选择时间')" style="width: 200px"> </DatePicker>
            </td>
          </tr>
          </tbody>
        </table>

        <table style="border-color: red;margin-top: 20px; " border="4">
          <thead>
          <th style="width: 130px;">第一位</th>
          <th style="width: 130px;">第二位</th>
          <th style="width: 130px;">第三位</th>
          <th style="width: 130px;">第四位</th>
          <th style="width: 130px;">第五位</th>
          <th style="width: 130px;">第六位</th>
          <th style="width: 130px;">特码</th>
          </thead>
          <tbody>
          <tr>
            <td style="text-align: center;"> <Input clearable v-model='windowAddItem.num1'
                                                    :placeholder="$t('请输入第一位')"></Input></td>
            <td style="text-align: center;"> <Input clearable v-model='windowAddItem.num2'
                                                    :placeholder="$t('请输入第二位')"></Input></td>
            <td style="text-align: center;"> <Input clearable v-model='windowAddItem.num3'
                                                    :placeholder="$t('请输入第三位')"></Input></td>
            <td style="text-align: center;"> <Input clearable v-model='windowAddItem.num4'
                                                    :placeholder="$t('请输入第四位')"></Input></td>
            <td style="text-align: center;"> <Input clearable v-model='windowAddItem.num5'
                                                    :placeholder="$t('请输入第五位')"></Input></td>
            <td style="text-align: center;"> <Input clearable v-model='windowAddItem.num6'
                                                    :placeholder="$t('请输入第六位')"></Input></td>
            <td style="text-align: center;"> <Input clearable v-model='windowAddItem.num7'
                                                    :placeholder="$t('请输入特码')"></Input></td>
          </tr>
          </tbody>
        </table>


      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('更新到数据库') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data() {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
              1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
                1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('完整期号'),
        key: 'yearIssue',

        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('期号'),
        key: 'issue',

        minWidth: 40,
        align: 'center'
      }

        , {
          title: this.$t('港澳'),
          align: 'center',
          minWidth: 80,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.isXg != 0 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.isXg != 0? '1px solid #ed4014' : '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, this.getGameName(params.row.isXg) ),
            ])
          }
        }, {
          title: this.$t('第一位'),
          key: 'num1',

          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('第二位'),
          key: 'num2',

          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('第三位'),
          key: 'num3',

          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('第四位'),
          key: 'num4',

          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('第五位'),
          key: 'num5',

          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('第六位'),
          key: 'num6',

          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('特码'),
          key: 'num7',

          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('开奖日期'),
          key: 'openTime',
          minWidth: 80,
          align: 'center'
        }, {
          title: this.$t('下期开奖日期'),
          key: 'nextOpenTime',
          minWidth: 80,
          align: 'center'
        }, {
          title: this.$t('下期期号'),
          key: 'nextissue',
          minWidth: 40,
          align: 'center'
        }, {
          title: this.$t('操作'),
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let vm = this
            return h('div', [h('Button', {
              props: {
                type: 'primary'
              },
              style: {
                margin: '0 5px'
              },
              on: {
                'click': () => {
                  let vm = this
                  vm.windowAddItem.id = params.row.id;
                  vm.windowAddItem.yearIssue = params.row.yearIssue;
                  vm.windowAddItem.issue = params.row.issue;
                  vm.windowAddItem.num1 = params.row.num1;
                  vm.windowAddItem.num2 = params.row.num2;
                  vm.windowAddItem.num3 = params.row.num3;
                  vm.windowAddItem.num4 = params.row.num4;
                  vm.windowAddItem.num5 = params.row.num5;
                  vm.windowAddItem.num6 = params.row.num6;
                  vm.windowAddItem.num7 = params.row.num7;
                  vm.windowAddItem.nextOpenTime = params.row
                    .nextOpenTime;
                  vm.windowAddItem.openTime = params.row.openTime;
                  vm.windowAddItem.nextissue = params.row.nextissue;

                  vm.windowAddItem.isXg = params.row.isXg.toString();
                  vm.windowAdd.show = true
                }
              }
            }, this.$t('编辑')), h('Poptip', {
              props: {
                confirm: true,
                title: this.$t('您确定要删除?'),
                transfer: true
              },
              on: {
                'on-ok': () => {

                  customPost('Lhc/openLogDel', {id:params.row.id}).then(response => {
                    this.tableData.splice(params.index, 1)
                    this.$Message.success(response.data.msg)
                  })
                  params.loading = false

                }
              }
            }, [
              h('Button', {
                style: {
                  margin: '0 5px'
                },
                props: {
                  type: this.$t('error'),
                  placement: 'top',
                  loading: params.isDeleting
                }
              }, this.$t('删除'))
            ])])
          }
        },
      ],
      tableData: [], //用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: {
        searchTime: [],
      }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: { //窗口校验规则
      }, //----------------
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcOpenLog/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted() {
    this.getParams()
  },
  methods: {
    getGameName(isXg){
      if(isXg==0){
        return "新澳门";
      }else  if(isXg==1){
        return "香港";
      }else  if(isXg==2){
        return "老澳门";
      }else  if(isXg==7){
        return "快乐8";
      }else  if(isXg==4){
        return "柬埔寨";
      }else  if(isXg==5){
        return "台湾";
      }else  if(isXg==6){
        return "印尼";
      }else  if(isXg==7){
        return "马来西亚";
      }
      return ""
    },
    preAdd() {
      let vm = this
      vm.windowAddItem.id = 0;
      vm.windowAddItem.yearIssue = '';
      vm.windowAddItem.issue = '';
      vm.windowAddItem.num1 = '';
      vm.windowAddItem.num2 = '';
      vm.windowAddItem.num3 = '';
      vm.windowAddItem.num4 = '';
      vm.windowAddItem.num5 = '';
      vm.windowAddItem.num6 = '';
      vm.windowAddItem.num7 = '';
      vm.windowAddItem.isXg = '';
      vm.windowAddItem.nextOpenTime = '';
      vm.windowAddItem.openTime = '';
      vm.windowAddItem.nextissue = '';
      vm.windowAdd.show = true
    },
    getParams() {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page = vm.tableShow.currentPage
      vm.searchConf.size = vm.tableShow.pageSize
      customPost('Lhc/openLogGetList', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function({
                           column,
                           key,
                           order
                         }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    },
    windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          customPost('Lhc/openLogAdd', vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    }
  }
}
</script>
